import request from './request'

/**
 * 获取积分总和
 * @param {string} trade_no 订单号
 */
export function getPoint(data) {
  return request.get('/getPointSum.php', {
    params: data
  })
}

/**
 * 获取积分明细
 * @param {string} trade_no 订单号
 */
export function getPointDetail(data) {
  return request.get('/getPointDetail.php', {
    params: data
  })
}
